import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function Loading() {
  return (
    <div className=" bg-black bg-opacity-25  fixed top-0 right-0 h-screen w-screen z-[9999] flex justify-center items-center">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-5 border-primary"></div>
    </div>
  );
}

export function LoadingItem() {
  return (
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-5 border-primary"></div>
  );
}

interface ChartAreaLoaderProps {
  title?: string;
  subtitle?: string;
}

export function ChartAreaLoader({
  title = "Loading Data",
  subtitle = "Fetching the latest insights…",
}: ChartAreaLoaderProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "650px",
        gap: "4px",
      }}
    >
      <DotLottieReact
        src="https://lottie.host/e5d43299-8a12-4fd2-9cd9-17750f9f56c5/lZjt4YNRaX.lottie"
        loop
        autoplay
        style={{ width: 200, height: 200 }}
      />
      <p
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "#F1935C",
          letterSpacing: "0.06em",
          margin: 0,
          textTransform: "uppercase",
        }}
      >
        Preparing your latest insights
      </p>
      <p
        style={{
          fontSize: "12px",
          color: "#9ca3af",
          margin: 0,
        }}
      >
        Optimizing your analytics experience…
      </p>
    </div>
  );
}
